export const setPersisted = () => {
	return {
		type: 'PERSISTED'
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/persist.js